import {
  type ReadonlyFieldProps,
  type FormDateInputProps,
  FormDateInput,
  ReadonlyField,
  CalendarTodayIcon,
  Flex,
  Text,
} from '@shared/components';
import { type FieldValues } from 'react-hook-form';

import { type BaseViewModeProps, type BaseInputModeProps } from '../../types';

type InputModeProps = BaseInputModeProps<Omit<FormDateInputProps<FieldValues>, 'name'>>;

type ViewModeProps = BaseViewModeProps<Omit<ReadonlyFieldProps, 'content' | 'maxLines'>>;

export type DateInputRendererProps = InputModeProps | ViewModeProps;

export default function DateInputRenderer(props: Readonly<DateInputRendererProps>) {
  switch (props.mode) {
    case 'input': {
      const { name, slotProps } = props;
      return <FormDateInput name={name} {...slotProps} />;
    }
    case 'view': {
      const { value, slotProps } = props;
      const { ...readonlyFieldProps } = slotProps || {};
      return (
        <ReadonlyField
          content={
            <Flex
              sx={{
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Text component='span'>{value}</Text>
              <CalendarTodayIcon sx={(theme) => ({ color: theme.palette.text.secondary })} />
            </Flex>
          }
          {...readonlyFieldProps}
        />
      );
    }
  }
}
